import { render, staticRenderFns } from "./chooseCouponPoolSend.vue?vue&type=template&id=8c4bee00&scoped=true"
import script from "./chooseCouponPoolSend.vue?vue&type=script&lang=js"
export * from "./chooseCouponPoolSend.vue?vue&type=script&lang=js"
import style0 from "./chooseCouponPoolSend.vue?vue&type=style&index=0&id=8c4bee00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4bee00",
  null
  
)

export default component.exports